// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"eb479f1ac4ddc71ecef5","792":"b9387793687f0fea1397"}[chunkId] + ".css";
};